import { axios } from '../utils/apiUtils';
import React, { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { setSession } from '../utils/authUtils'
import PasswordRecovery from './passwordRecovery';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 12 },
};

const styles = {
  alert: {
    marginTop: '16px',
    marginBottom: '16px',
  },
};

const LoginModal = (props) => {
  const { t } = useTranslation();

  const [user, setUser] = useState();
  const [password, setPassword] = useState();

  const [showError, setShowError] = useState();
  
  const [sendPasswordReset, setSendPasswordReset] = useState();
  const [goToRegister, setGoToRegister] = useState();

  const startChungungoSession = (event) => {
    event.preventDefault();

    axios.post(
      `${process.env.REACT_APP_API_URL}/auth/login`,
      { 
        email: user,
        password: password,
      },
      {
        headers: { 'Content-Type': 'application/json' }
      },
    ).then((loginResponse) => {
      const userFromServer = loginResponse.data;

      setSession(userFromServer);
      props.onClose();
    }).catch((error) => {
      setShowError(error);
    });
  }

  if (goToRegister) {
    props.onClose();
    return <Redirect to="/register"/>
  }

  if (sendPasswordReset) {
    return <PasswordRecovery user={user} onClose={props.onClose} />
  }

  return (
    <Modal show="true" onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('login.modal.title')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {showError && 
          <Alert
            style={styles.alert}
            variant="danger" >
              {showError.response.data.error === 'Mail has not been validated' &&
                <p>{t('login.alert.mailnotvalid')}</p>
              }
              {showError.response.data.error !== 'Mail has not been validated' &&
                <p>{t('login.alert.noauth')}</p>
              }
          </Alert>
        }

        <Form
          onSubmit={startChungungoSession}
          {...layout}
          name='login'
          initialValues={{ remember: true }}
        >
          <Form.Group
            label={t('login.label.email')}
            name='user'
            rules={[{ required: true, message: t('login.warning.noemail') }]}
          >
            <Form.Control type="text" id="user" placeholder="Nombre de usuario" value={user} onChange={(evt) => setUser(evt.target.value)}/>
          </Form.Group>
          <Form.Group
            label={t('login.label.password')}
            name='password'
            rules={[{ required: true, message: t('login.warning.badpassword') }]}
          >
            <Form.Control type="password" id="password" placeholder="Contraseña" password={password} onChange={(evt) => setPassword(evt.target.value)}/>
          </Form.Group>
          <Form.Group
            {...tailLayout}
          >
            <Button
              variant="outline-dark"
              type="submit"
            >
              {t('login.button.submit')}
            </Button>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="outline-dark"
          onClick={() => setGoToRegister(true)}
        >{t('login.modal.buttons.register')}</Button>
        <Button
          variant="outline-dark"
          onClick={() => setSendPasswordReset(true)}
        >{t('login.modal.buttons.forgot_password')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginModal;